/* v94.1: product page share becomes a small icon beside the price.
   pw-share mounts its box into the gallery ([data-pw-share-mount]); this moves it next to the price. */
(function(){
  function move(){
    var price=document.querySelector('.pw-buy .pw-price');
    var box=document.querySelector('[data-pw-share-mount] .pw-share, .pw-share[data-pw-share]');
    if(!price||!box||box.classList.contains('pw-share--mini'))return !!(price&&box);
    box.classList.add('pw-share--mini');
    price.appendChild(box);
    return true;
  }
  function run(){var n=0;(function t(){if(move()||++n>40)return;setTimeout(t,150);})();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
